import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, TextField, Snackbar, Alert, Dialog, DialogActions, DialogTitle   } from '@mui/material';
import axios from 'axios'

let date = new Date();
let year = date.getFullYear();
let month = date.getMonth();
month += 1;
if (month <= 9){
    month = "0" + month;
}
let day = date.getDate();
if (day <= 9){
    day = "0" + month;
}
let today = year + '-' + month + '-' + day;
let nowMonth = year + '-' + month;

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  incomConfigBlockH1:{
    padding:'40px 0 0px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  firstDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }

  },
  secondDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  thirdDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',
    
    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  fourthDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',
    
    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px'
    }
  },
  fistTextField:{
    marginLeft:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px'
    }
  },
  secondTextField:{
    marginLeft:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px'
    }
  },
  buttonbutton:{
    marginLeft:'10px',
  },
  button:{
    [theme.breakpoints.down(1025)]: {
      padding:'100px'
    }
  },

}));

const IncomConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const [param, setParam] = useState(0)

  const [dayDate, setDayDate] = useState(today)

  const [staDayDate, setStaDayDate] = useState(today)
  const [endDayDate, setEndDayDate] = useState(today)

  const [staMonthDate, setStaMonthDate] = useState(nowMonth)
  const [endMonthDate, setEndMonthDate] = useState(nowMonth)

  const [staYearDate, setStaYearDate] = useState(year)
  const [endYearDate, setEndYearDate] = useState(year)

  const [dialog, setDialog] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className={classes.incomConfigBlock}>
      <div className={classes.box}>
        <h1 className={classes.incomConfigBlockH1}>매출현황</h1>
        <div className={classes.firstDiv}>
          <span className={classes.spanSpan}>일일 매출</span>
            <div className={classes.fistTextField}>
              <TextField
                type="date"
                value={dayDate}
                sx={{ width: 220 }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  setDayDate(e.target.value)
                }}
              />
            </div>
            <div className={classes.buttonbutton}>
              <Button 
                variant="outlined"
                onClick={() => {
                  const today1 = new Date(today);
                  const day1 = new Date(dayDate);
      
                  if(day1 > today1) return setDialog('현재일보다 선택일이 더 큽니다!')
                  setParam(1)
                }}    
              >
                확인
              </Button>
            </div>   
        </div>
        <div className={classes.secondDiv}>
          <span className={classes.spanSpan}>일간 매출</span>
          <div className={classes.fistTextField}>
            <TextField
              type="date"
              label="시작일"
              value={staDayDate}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setStaDayDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.secondTextField}>
            <TextField
              type="date"
              label="종료일"
              value={endDayDate}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setEndDayDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.buttonbutton}>
            <Button 
              variant="outlined"
              onClick={() => {
                const today1 = new Date(today);
                const day1 = new Date(staDayDate);
                const day2 = new Date(endDayDate);
    
                if(day2 > today1) return setDialog('현재일보다 선택일이 더 큽니다!')
                if(day1 > day2) return setDialog('시작일이 종료일보다 더 큽니다!')
                setParam(2)
              }}    
            >
              확인
            </Button> 
          </div>
        </div>
        <div className={classes.thirdDiv}>
          <span className={classes.spanSpan}>월간 매출</span>
          <div className={classes.fistTextField}>
            <TextField
              type="month"
              label="시작월"
              value={staMonthDate}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setStaMonthDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.secondTextField}>
            <TextField
              type="month"
              label="종료월"
              value={endMonthDate}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setEndMonthDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.buttonbutton}>
            <Button 
              variant="outlined"
              onClick={() => {
                const nowMonth1 = new Date(nowMonth);
                const month1 = new Date(staMonthDate);
                const month2 = new Date(endMonthDate);
    
                if(month2 > nowMonth1) return setDialog('현재월보다 선택월이 더 큽니다!')
                if(month1 > month2) return setDialog('시작월이 종료월보다 더 큽니다!')
                setParam(3)
              }}    
            >
              확인
            </Button>
          </div>     
        </div>
        <div className={classes.fourthDiv}>
          <span className={classes.spanSpan}>연간 매출</span>
          <div className={classes.fistTextField}>
            <TextField
              value={staYearDate}
              type='number'
              onChange={(e) => {
                setStaYearDate(e.target.value) 
              }}
            />
          </div>
          <div className={classes.secondTextField}>
            <TextField
              value={endYearDate}
              type='number'
              onChange={(e) => {
                setEndYearDate(e.target.value) 
              }}
            />
          </div>
          <div className={classes.buttonbutton}>
            <Button 
              variant="outlined"
              onClick={() => {
                if(endYearDate > year) return setDialog('현재년도보다 선택년도가 더 큽니다!')
                if(staYearDate > endYearDate) return setDialog('시작년도가 종료년도보다 더 큽니다!')
                setParam(4)
              }}    
            >
              확인
            </Button>  
          </div>  
        </div>
        {param === 1 && <DaySalesReport day={dayDate} />}
        {param === 2 && <DaysSalesReport staDay={staDayDate} endDay={endDayDate} />}
        {param === 3 && <MonthSalesReport staMonth={staMonthDate} endMonth={endMonthDate} />}
        {param === 4 && <YearSalesReport staYear={staYearDate} endYear={endYearDate} />}
      </div>
      <Dialog
        open={dialog === '' ? false : true}
        onClose={() => setDialog('')}
      >
        <DialogTitle id="alert-dialog-title">
          {dialog}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setDialog('')} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>
      
      
    </div>
  )
}




const useStylesReport = makeStyles((theme)=>({
  main: {
    paddingBottom:'30px'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(516)]: {
      fontSize:'10px'
    },

  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeft: '1px solid #D3D3D3',
    borderTop:'none',
    padding:'5px 0'
  },
  contBox: {
    display: 'flex',
    borderTop: '1px solid #D3D3D3',
    alignItems: 'center',
  },
  contBoxItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    wordBreak:'break-all',

    [theme.breakpoints.down(516)]: {
      fontSize:'10px'
    }, 
  },
  textLeft: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textRight: { 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textMiddle: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  imageText: {
    display: 'flex',
    alignItems: 'center'
  },
  totalDiv:{
    paddingTop:'50px'
  },


}));


const DaySalesReport = ({day}) => {
  const row = [
    {name: '주문번호', width: '14%'},
    {name: '주문자', width: '14%'},
    {name: '주문합계', width: '14%'},
    {name: '입금', width: '10%'},
    {name: '포인트입금', width: '20%'},
    {name: '주문취소', width: '14%'},
    {name: '미수금', width: '14%'},
  ];

  const [data, setData] = useState([])
  const [sums, setSums] = useState({})

  const theme = useTheme();
  const classes = useStylesReport(theme);
  const [errSnack, setErrSnack] = useState(false);

  const getItems = async() => {
    try {
      const res = await axios.post('/api/adm/daySalesReport/', {date: day} )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_id'], data: item['od_id'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_name'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_cart_price'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_receipt_price'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_receipt_point'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_cancel_price'], type: 'textMiddle'},
        {id: item['od_id'], data: item['od_misu'], type: 'textMiddle'},
        ]
      ], []))
      
      setSums(res.data.total)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()

    return () => {
      setData([])
    }
  }, [])


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
  };


  return (
    <div className={classes.main}>


      <div className={classes.datagridBox}>
        <div className={classes.datagridTop}>
          {row.map((item, index) => (
                    <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                      {item.name}
                    </div>
          ))}
        </div>

        {data.length > 0 && data.map((dataItem, dataIndex) => {
          return(
                  <div key={dataIndex} className={classes.contBox}>
                      {dataItem.map((item, index) => {
                        return(
                              <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                {item.type === 'textLeft' && (
                                  <h3 className={classes.textLeft}>{item.data}</h3>
                                )}
                                {item.type === 'textRight' && (
                                  <h3 className={classes.textRight}>{item.data}</h3>
                                )}
                                {item.type === 'textMiddle' && (
                                  <h3 className={classes.textMiddle}>{item.data}</h3>
                                )}
                              </div>
                      )})}
                  </div>
        )})}

      </div>
      
      <div className={classes.totalDiv}>
        <div>
          주문합계: {sums.totalCart}
        </div>
        <div>
          입금합계: {sums.totalBank}
        </div>
        <div>
          포인트합계: {sums.totalPoint}
        </div>
        <div>
          주문취소합계: {sums.totalCancel}
        </div>
        <div>
          미수금합계: {sums.totalMisu}
        </div>
      </div>


      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      

    </div>
  )
}


const DaysSalesReport = ({staDay, endDay}) => {
  const row = [
    {name: '주문일', width: '14%'},
    {name: '주문수', width: '14%'},
    {name: '주문합계', width: '14%'},
    {name: '입금', width: '10%'},
    {name: '포인트입금', width: '20%'},
    {name: '주문취소', width: '14%'},
    {name: '미수금', width: '14%'},
  ];

  const [data, setData] = useState([])
  const [sums, setSums] = useState({})

  const theme = useTheme();
  const classes = useStylesReport(theme);
  const [errSnack, setErrSnack] = useState(false);

  const getItems = async() => {
    try {
      const res = await axios.post('/api/adm/daysSalesReport/', {start_date: staDay, end_date: endDay} )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_day'], data: item['od_day'], type: 'textMiddle'},
        {id: item['od_day'], data: item['order_count'], type: 'textMiddle'},
        {id: item['od_day'], data: item['od_cart'], type: 'textMiddle'},
        {id: item['od_day'], data: item['od_receipt_price'], type: 'textMiddle'},
        {id: item['od_day'], data: item['od_receipt_point'], type: 'textMiddle'},
        {id: item['od_day'], data: item['od_cancel_price'], type: 'textMiddle'},
        {id: item['od_day'], data: item['od_misu'], type: 'textMiddle'},
        ]
      ], []))
      
      setSums(res.data.total)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()

    return () => {
      setData([])
    }
  }, [])

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
  };


  return (
    <div className={classes.main}>


      <div className={classes.datagridBox}>
        <div className={classes.datagridTop}>
          {row.map((item, index) => (
                    <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                      {item.name}
                    </div>
          ))}
        </div>

        {data.length > 0 && data.map((dataItem, dataIndex) => {
          return(
                  <div key={dataIndex} className={classes.contBox}>
                      {dataItem.map((item, index) => {
                        return(
                              <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                {item.type === 'textLeft' && (
                                  <h3 className={classes.textLeft}>{item.data}</h3>
                                )}
                                {item.type === 'textRight' && (
                                  <h3 className={classes.textRight}>{item.data}</h3>
                                )}
                                {item.type === 'textMiddle' && (
                                  <h3 className={classes.textMiddle}>{item.data}</h3>
                                )}
                              </div>
                      )})}
                  </div>
        )})}

      </div>
      
      <div className={classes.totalDiv}>
        <div>
          주문수합계: {sums.totalCount}
        </div>
        <div>
          주문합계: {sums.totalCart}
        </div>
        <div>
          입금합계: {sums.totalBank}
        </div>
        <div>
          포인트합계: {sums.totalPoint}
        </div>
        <div>
          주문취소합계: {sums.totalCancel}
        </div>
        <div>
          미수금합계: {sums.totalMisu}
        </div>
      </div>


      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      

    </div>
  )
}


const MonthSalesReport = ({staMonth, endMonth}) => {
  const row = [
    {name: '주문월', width: '14%'},
    {name: '주문수', width: '14%'},
    {name: '주문합계', width: '14%'},
    {name: '입금', width: '10%'},
    {name: '포인트입금', width: '20%'},
    {name: '주문취소', width: '14%'},
    {name: '미수금', width: '14%'},
  ];

  const [data, setData] = useState([])
  const [sums, setSums] = useState({})

  const theme = useTheme();
  const classes = useStylesReport(theme);
  const [errSnack, setErrSnack] = useState(false);

  const getItems = async() => {
    try {
      const res = await axios.post('/api/adm/monthSalesReport/', {start_month: staMonth, end_month: endMonth} )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_month'], data: item['od_month'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_count'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_cart'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_receipt_price'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_receipt_point'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_cancel_price'], type: 'textMiddle'},
        {id: item['od_month'], data: item['od_misu'], type: 'textMiddle'},
        ]
      ], []))
      
      setSums(res.data.total)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()

    return () => {
      setData([])
    }
  }, [])


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
  };


  return (
    <div className={classes.main}>


      <div className={classes.datagridBox}>
        <div className={classes.datagridTop}>
          {row.map((item, index) => (
                    <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                      {item.name}
                    </div>
          ))}
        </div>

        {data.length > 0 && data.map((dataItem, dataIndex) => {
          return(
                  <div key={dataIndex} className={classes.contBox}>
                      {dataItem.map((item, index) => {
                        return(
                              <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                {item.type === 'textLeft' && (
                                  <h3 className={classes.textLeft}>{item.data}</h3>
                                )}
                                {item.type === 'textRight' && (
                                  <h3 className={classes.textRight}>{item.data}</h3>
                                )}
                                {item.type === 'textMiddle' && (
                                  <h3 className={classes.textMiddle}>{item.data}</h3>
                                )}
                              </div>
                      )})}
                  </div>
        )})}

      </div>
      
      <div className={classes.totalDiv}>
        <div>
          주문수합계: {sums.totalCount}
        </div>
        <div>
          주문합계: {sums.totalCart}
        </div>
        <div>
          입금합계: {sums.totalBank}
        </div>
        <div>
          포인트합계: {sums.totalPoint}
        </div>
        <div>
          주문취소합계: {sums.totalCancel}
        </div>
        <div>
          미수금합계: {sums.totalMisu}
        </div>
      </div>


      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      

    </div>
  )
}



const YearSalesReport = ({staYear, endYear}) => {
  const row = [
    {name: '주문년도', width: '14%'},
    {name: '주문수', width: '14%'},
    {name: '주문합계', width: '14%'},
    {name: '입금', width: '10%'},
    {name: '포인트입금', width: '20%'},
    {name: '주문취소', width: '14%'},
    {name: '미수금', width: '14%'},
  ];

  const [data, setData] = useState([])
  const [sums, setSums] = useState({})

  const theme = useTheme();
  const classes = useStylesReport(theme);
  const [errSnack, setErrSnack] = useState(false);

  const getItems = async() => {
    try {
      const res = await axios.post('/api/adm/yearSalesReport/', {start_year: staYear, end_year: endYear} )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_year'], data: item['od_year'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_count'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_cart'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_receipt_price'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_receipt_point'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_cancel_price'], type: 'textMiddle'},
        {id: item['od_year'], data: item['od_misu'], type: 'textMiddle'},
        ]
      ], []))
      
      setSums(res.data.total)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getItems()

    return () => {
      setData([])
    }
  }, [])

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
  };


  return (
    <div className={classes.main}>


      <div className={classes.datagridBox}>
        <div className={classes.datagridTop}>
          {row.map((item, index) => (
                    <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                      {item.name}
                    </div>
          ))}
        </div>

        {data.length > 0 && data.map((dataItem, dataIndex) => {
          return(
                  <div key={dataIndex} className={classes.contBox}>
                      {dataItem.map((item, index) => {
                        return(
                              <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                {item.type === 'textLeft' && (
                                  <h3 className={classes.textLeft}>{item.data}</h3>
                                )}
                                {item.type === 'textRight' && (
                                  <h3 className={classes.textRight}>{item.data}</h3>
                                )}
                                {item.type === 'textMiddle' && (
                                  <h3 className={classes.textMiddle}>{item.data}</h3>
                                )}
                              </div>
                      )})}
                  </div>
        )})}

      </div>
      
      <div className={classes.totalDiv}>
        <div>
          주문수합계: {sums.totalCount}
        </div>
        <div>
          주문합계: {sums.totalCart}
        </div>
        <div>
          입금합계: {sums.totalBank}
        </div>
        <div>
          포인트합계: {sums.totalPoint}
        </div>
        <div>
          주문취소합계: {sums.totalCancel}
        </div>
        <div>
          미수금합계: {sums.totalMisu}
        </div>
      </div>


      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      

    </div>
  )
}




export default IncomConfig
